import { CategoryJsonPage, DiscussionJsonPage } from "../interfaces/JsonPage";
import Event, { EventPaginated } from "../interfaces/Event";
import SelectItem from "../interfaces/SelectItem";
import {
  VanillaApiCurrentUser,
  VanillaApiTag,
  VanillaApiUser,
  VanillaCategory,
  VanillaDiscussion,
  VanillaPoll,
} from "../interfaces/VanillaApi";
import Tag from "../interfaces/Tag";

enum ProviderConfiguration {
  local = "local",
  vanilla = "vanilla",
  apex = "apex",
  ocontent = "ocontent",
}

enum CommunityProviderType {
  Discussions = "Discussions",
  Events = "Events",
  Tips = "Tips",
  Users = "Users",
  Polls = "Polls",
  Default = "Default",
}

enum ApexProviderType {
  Parent = "Parent",
  Jira = "Jira",
  BugDB = "BugDB",
}

enum OcontentProviderType {
  Twitter = "Twitter",
  Misc = "Misc",
  IntroText = "IntroText",
  Quicklinks = "Quicklinks",
  Youtube = "Youtube",
  Announcements = "Announcements",
  EventVideoReplay = "EventVideoReplay",
  MonthlyTheme = "MonthlyTheme",
}

interface VanillaProvider {
  getCategoryFromJsonPage: (
    catUrl?: string
  ) => Promise<CategoryJsonPage | null>;
  getCategory: (categoryId: number) => Promise<VanillaCategory | null>;
  getDiscussionFromJsonPage: () => Promise<DiscussionJsonPage | null>;
  getDiscussion: (discussionId: number) => Promise<VanillaDiscussion | null>;
  getCurrentUser: () => Promise<VanillaApiCurrentUser | null>;
  getUsersByName: (keyword: string) => Promise<Array<VanillaApiUser> | null>;
  getTags: (a: Array<string>) => Promise<Array<VanillaApiTag>>;
  getCategories: (
    queryOptions?: Array<string>
  ) => Promise<Array<VanillaCategory>>;
}

interface EventsProvider extends VanillaProvider {
  getEvents: (
    a: string,
    b: string,
    c: number,
    d?: string,
    e?: boolean,
    f?: number,
    g?: number
  ) => Promise<Array<Event> | EventPaginated>;
  rsvpEvent: (a: string, b: number) => Promise<boolean>;
}

interface TipsProvider extends VanillaProvider {
  getCategoryTags: (a: number) => Promise<Array<SelectItem>>;
  getTips: (a: Tag, b: number) => Promise<Array<VanillaDiscussion>>;
  lookupForTipTag(parentTagId: number): Promise<Tag | null>;
}

interface PollsProvider extends VanillaProvider {
  getPolls: () => Promise<VanillaPoll | null>;
  answerPoll: (a: number, b: number, c: number) => Promise<null>;
}

export {
  ProviderConfiguration,
  CommunityProviderType,
  ApexProviderType,
  OcontentProviderType,
  VanillaProvider,
  EventsProvider,
  TipsProvider,
  PollsProvider,
};
